import { render, staticRenderFns } from "./ClientSpecialistItem.vue?vue&type=template&id=88162eba&scoped=true&"
import script from "./ClientSpecialistItem.vue?vue&type=script&lang=js&"
export * from "./ClientSpecialistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88162eba",
  null
  
)

export default component.exports